import type { Role } from '@repo/api-gw-sdk';

const rolesOrder: Record<string, number> = {
  '543bad56-e9b2-421f-8456-b43c53fcebfe': 0, // Global viewer
  '379a1104-838a-4bf3-af96-da3af27c5712': 1, // Global admin
  'd6afa067-d3a0-457e-923d-27cd26c9e5cb': 2, // Viewer
  '21d0ae2b-9bbc-4a41-bd5e-98011e9f10a5': 3, // Operator
  'a675e456-8602-4550-9c65-66583404e0d6': 4, // Admin
};

export const rolesComparer = (a: Role, b: Role) => {
  if (a.isBuiltInRole || b.isBuiltInRole) {
    if (a.isBuiltInRole && b.isBuiltInRole) {
      return rolesOrder[a.id] - rolesOrder[b.id];
    } else if (a.isBuiltInRole) {
      return -1;
    } else {
      return 1;
    }
  }

  return a.name.localeCompare(b.name);
};
